import React from "react";
import { ProductRating } from "../../../types/interfaces";
import { RatingStar } from "../../common";
import helpers from "../../../_helpers/common";

interface ReviewCardProps {
  reviews: ProductRating[];
}

const ReviewCard: React.FC<ReviewCardProps> = ({ reviews }) => {
  //console.log('npo reviews', reviews)
  return (
    <>
      {reviews.map((item, index) => (
        <div key={index} className="card mt-5 p-3 bg-light-secondary">
          <div className="row gy-4 align-items-start">
            {/* Profile Info */}
            <div className="col-md-3 col-12 d-flex align-items-start">
                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                  <div className="symbol-label">
                    <img
                      src={item?.created_by?.imagepath}
                      alt="profile"
                      className="w-100 h-100"
                    />
                  </div>
                </div>
                <div className="d-flex flex-column text-break">
                  <span className="text-gray-800 text-hover-primary fw-semibold">
                    {item?.created_by?.fullname}
                  </span>
                  {/*<span>{item?.created_by?.email}</span>*/}
                </div>
            </div>

            {/* Rating, Message */}
            <div className="col-12 col-md-8">
              <div className="d-flex mb-3 flex-column flex-md-row justify-content-between flex-wrap">
                <RatingStar rating={item?.rating} />
                <span className="ms-5 fs-5">
                  {helpers.convertDateTime(item?.created_at, "DD MMM YYYY")}
                </span>
              </div>
              <p className="fw-bold mb-2">{item?.title}</p>
              <p className="mb-3" style={{ overflowWrap: 'anywhere' }}>{item?.message}</p>
            </div>

          </div>
        </div>
      ))}
    </>
  );
};

export default ReviewCard;
